import { ApiClient } from './api/index.ts'
import type {
  DeleteAccountResponse,
  RestoreAccountResponse,
  UserAccountStatus,
} from './api/types.ts'

/**
 * Get user account status including deletion schedule
 */
export async function getUserAccountStatus(): Promise<UserAccountStatus> {
  const result = await ApiClient.invoke<UserAccountStatus>(
    'user_account_status',
    {
      body: {},
    },
  )

  if (!result.success) {
    const errorMessage =
      result.error?.message || 'Failed to load account status. Please try again.'
    throw new Error(errorMessage)
  }

  return result.data!
}

/**
 * Request account deletion with 30-day grace period
 * Requires password verification and "DELETE" confirmation
 */
export async function requestAccountDeletion(
  password: string,
  confirmation: string,
): Promise<DeleteAccountResponse> {
  const result = await ApiClient.invoke<DeleteAccountResponse>(
    'user_account_delete',
    {
      body: {
        password,
        confirmation,
      },
    },
  )

  if (!result.success) {
    const errorMessage =
      result.error?.message || 'Failed to schedule account deletion. Please try again.'
    throw new Error(errorMessage)
  }

  return result.data!
}

/**
 * Restore account that is scheduled for deletion
 * Only works within the 30-day grace period
 */
export async function restoreAccount(): Promise<RestoreAccountResponse> {
  const result = await ApiClient.invoke<RestoreAccountResponse>(
    'user_account_restore',
    {
      body: {},
    },
  )

  if (!result.success) {
    const errorMessage =
      result.error?.message || 'Failed to restore account. Please try again.'
    throw new Error(errorMessage)
  }

  return result.data!
}
